<script>
import { printByUsb } from '../../pdv/services/printer/usbPrinterService.js';
import { printByBluetooth } from '../../pdv/services/printer/bluetoothPrinterService.js';
import { printByNet } from '../../pdv/services/printer/netPrinterService.js';
import { printWithRetry, ensureBridgeAlive } from '../../pdv/services/printer/androidPrinterService.js';
import { isAndroid } from '../../pdv/services/printer/platformDetector.js';
import { toast } from "vue3-toastify";

export default {
    data() {
        return {
            lastPrintErrorCode: null,
            printerCommands: {
                ESC_INIT: "\x1B\x40", // Inicializar impresora
                ESC_ALIGN_CENTER: "\x1B\x61\x01", // Alineación centrada
                ESC_BOLD_ON: "\x1B\x45\x01", // Activar negrilla
                ESC_BOLD_OFF: "\x1B\x45\x00", // Desactivar negrilla
                GS_DOUBLE_STRIKE_ON: "\x1B\x47\x01", // Doble golpe activado (negrilla gruesa)
                GS_DOUBLE_STRIKE_OFF: "\x1B\x47\x00", // Doble golpe desactivado
                GS_TEXT_SIZE: "\x1D\x21", // Comando de tamaño de texto
                TEXT_NORMAL: "\x00", // Tamaño normal
                TEXT_DOUBLE_HEIGHT: "\x01", // Doble alto
                TEXT_DOUBLE_WIDTH: "\x10", // Doble ancho
                TEXT_QUAD_SIZE: "\x11", // Doble alto y ancho
            },
        }
    },
    methods: {
        setFontLarge(content) {
            return `${this.printerCommands.ESC_INIT}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_QUAD_SIZE}${content}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_NORMAL}`;
        },
        setFontCenter(content) {
            return `${this.printerCommands.ESC_INIT}${this.printerCommands.ESC_ALIGN_CENTER}${content}${this.printerCommands.ESC_ALIGN_CENTER}`;
        },
        setFontBold(content) {
            return `${this.printerCommands.ESC_INIT}${this.printerCommands.ESC_BOLD_ON}${this.printerCommands.GS_DOUBLE_STRIKE_ON}${content}${this.printerCommands.ESC_BOLD_OFF}${this.printerCommands.GS_DOUBLE_STRIKE_OFF}`;
        },
        setFontLargeAndBold(content) {
            return `${this.printerCommands.ESC_INIT}${this.printerCommands.ESC_BOLD_ON}${this.printerCommands.GS_DOUBLE_STRIKE_ON}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_QUAD_SIZE}${content}${this.printerCommands.ESC_BOLD_OFF}${this.printerCommands.GS_DOUBLE_STRIKE_OFF}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_NORMAL}`;
        },
        setFontDoubleHeight(content) {
            return `${this.printerCommands.ESC_INIT}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_DOUBLE_HEIGHT}${content}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_NORMAL}`;
        },
        setFontDoubleWidth(content) {
            return `${this.printerCommands.ESC_INIT}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_DOUBLE_WIDTH}${content}${this.printerCommands.GS_TEXT_SIZE}${this.printerCommands.TEXT_NORMAL}`;
        },
        async printInCounter(content) {
            const config = (this.getPrinterConfig()).counter;

            if (config && config.label != 'Ninguna') {
                return await this.printTicket(content, config);
            }
        },
        async printInKitchen(content) {
            const config = (this.getPrinterConfig()).kitchen;
            if (config && config.label != 'Ninguna') {
                return await this.printTicket(content, config);
            }
        },
        async printInAdditional(content) {
            const config = (this.getPrinterConfig()).additional;
            if (config && config.label != 'Ninguna') {
                return await this.printTicket(content, config);
            }
        },
        async printTicket(content, config) {
            let result = false;
            this.$store.initLoading(this);
        try {
            if (isAndroid() && config.androidPrinter) {
                try {
                    const bridgeReady = await ensureBridgeAlive();
                    if (!bridgeReady) {
                        toast.error("El servicio de impresión no está disponible. Intentá nuevamente o contactá a soporte técnico.");
                        this.$store.finishLoading(this);
                        return false;
                    }
                    result = await printWithRetry(content, config.androidPrinter);
                } catch (err) {
                    console.error("Error Android print:", err.message);
                    if (err.printerError) {
                        toast.error(err.message);
                        this.lastPrintErrorCode = err.statusCode || null;
                        this.$store.finishLoading(this);
                        return false;
                    }
                    result = false;
                }
            } else {
                switch (config.type) {
                    case 'usb': {
                        try {
                            result = await printByUsb(content, config.value);
                        } catch (err) {
                            console.error("Error USB:", err.message);
                            result = false;
                        }
                        break;
                    }
                    case 'bluetooth': {
                        result = await printByBluetooth(content, config.value);
                        break;
                    }
                    case 'net': {
                        result = await printByNet(content, config);
                        break;
                    }
                    default: {
                        console.error('Unknown printer type: ', config.type);
                        result = false;
                    }
                }
            }
            if (result === false) {
                toast.error("No se pudo conectar con la impresora. Por favor, verifique su conexión.");
                await new Promise(resolve => setTimeout(resolve, 2000));
            }
        } catch (err) {
            console.error("Error inesperado en el proceso de impresión:", err.message);
            toast.error("Ocurrió un error inesperado al imprimir.");
        }
            this.$store.finishLoading(this);
            return result;
        },
        setupPrinters() {
            // TODO: setup printers from api
            const printerConfig = localStorage["printersConfig"];
            if (!printerConfig) {
                localStorage["printersConfig"] =
                '{"counter":{"type":"","label":"Ninguna","ip":""}}';
            }
        },
        getPrinterConfig() {
            const configString = localStorage.getItem("printersConfig");
            if (!configString) {
                this.setupPrinters()
            }
            return JSON.parse(localStorage["printersConfig"]);
        }
    }
}
</script>